export enum FedexPackagingEnum {
  YOUR_PACKAGING = "YOUR_PACKAGING",
  FEDEX_PAK = "FEDEX_PAK",
  FEDEX_BOX = "FEDEX_BOX",
  FEDEX_TUBE = "FEDEX_TUBE",
  FEDEX_ENVELOPE = "FEDEX_ENVELOPE",
  FEDEX_10KG_BOX = "FEDEX_10KG_BOX",
  FEDEX_25KG_BOX = "FEDEX_25KG_BOX",
}
